import React from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

function Header() {
  return (
    <SoftBox position="relative">
      <DashboardNavbar absolute light/>
      <SoftBox
        display="flex"
        alignItems="center"
        justifyContent="center"
        position="relative"
        minHeight="12rem"
        borderRadius="xl"
        sx={{
          backgroundImage: ({ functions: { rgba, linearGradient } }) =>
            `${linearGradient(
              rgba("#8b0000", 0.9), // Red from login
              rgba("#4B0082", 0.9) // Dark purple
            )}, url('https://via.placeholder.com/1920x400')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          overflow: "hidden",
          boxShadow: "0 10px 20px rgba(0, 0, 0, 0.1)", // Enhanced shadow for depth
        }}
      >
        <SoftTypography variant="h3" color="white" fontWeight="bold">
          Entdecken Sie unsere SAAS-Produkte
        </SoftTypography>
      </SoftBox>
    </SoftBox>
  );
}

export default Header;
